import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { resetPasswordRequest } from '../../services/auth/forgotPasswordService.js';
import {isPasswordValid } from '../../utils/validations/forgotPasswordValidations.js';
import ROUTES from '../../routes/Routes.js';

export const useResetPassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);

    /* modales */
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const location = useLocation();
    const navigate = useNavigate();

    const token = new URLSearchParams(location.search).get('token'); // Obtén el token del query string

    const handleSubmit = async (e) => {
        e.preventDefault();
        // validaciones
        if (!isPasswordValid(password)) {
            setErrorMessage('La contraseña debe tener al menos 7 caracteres.');
            setShowErrorModal(true);
            return;
        }
        if (password !== confirmPassword) {
            setErrorMessage('Las contraseñas no coinciden.');
            setShowErrorModal(true);
            return;
        }
        if (!token) {
            setErrorMessage('Token inválido o expirado.');
            setShowErrorModal(true);
            return;
        }

        try {
            setLoading(true);
            await resetPasswordRequest(token, password);
            setSuccessMessage('Contraseña actualizada correctamente.');
            setShowSuccessModal(true);
            // Redirección automática opcional
            setTimeout(() => {
                navigate(ROUTES.LOGIN);
            }, 3000);
        } catch (error) {
            setErrorMessage(error.response?.data?.message || 'Error en el restablecimiento de contraseña.' );
            setShowErrorModal(true);
        } finally {
            setLoading(false);
        }
    };

    const closeSuccessModal = () => {
        setShowSuccessModal(false);
        navigate(ROUTES.LOGIN);
    };

    const closeErrorModal = () => {
        setShowErrorModal(false);
    };

    return {
        password,
        confirmPassword,
        setPassword,
        setConfirmPassword,
        loading,
        handleSubmit,
        showErrorModal,
        errorMessage,
        closeErrorModal,
        showSuccessModal,
        successMessage,
        closeSuccessModal
    };
};